export const TEAM_GQL_TYPE = 'JiraTeamViewField';
